import { ButtonLinkFieldViewModel } from '@/src/shared/presentation/view-models/button-link-field.viewModel';
import { FileFieldViewModel } from '@/src/shared/presentation/view-models/file-field.viewModel';

import { TextFieldViewModel } from '../text-field.viewModel';

import type { ICMSBlockViewModel } from '../../types/cms-block.viewModel';
import type { PromotedBlock } from '@/src/cms/domain/models/blocks/promoted-block';

export class PromotedBlockViewModel implements ICMSBlockViewModel {
  readonly $type = 'promoted-block' as const;

  title: string;
  subtitle: string | null;
  body: TextFieldViewModel | null;
  image: FileFieldViewModel | null;
  opacity: boolean;
  button: ButtonLinkFieldViewModel | null;
  hide: boolean;

  constructor(data: {
    title: string;
    subtitle: string | null;
    body: TextFieldViewModel | null;
    image: FileFieldViewModel | null;
    button: ButtonLinkFieldViewModel | null;
    opacity: boolean;
    hide: boolean;
  }) {
    this.title = data.title;
    this.subtitle = data.subtitle;
    this.body = data.body;
    this.image = data.image;
    this.button = data.button;
    this.opacity = data.opacity;
    this.hide = data.hide;
  }

  static presenter(block: PromotedBlock): PromotedBlockViewModel {
    return new PromotedBlockViewModel({
      title: block.title,
      subtitle: block.subtitle,
      body: block.body && TextFieldViewModel.presenter(block.body),
      image: block.image && FileFieldViewModel.presenter(block.image),
      button: block.button && ButtonLinkFieldViewModel.presenter(block.button),
      opacity: block.opacity,
      hide: block.hide
    });
  }
}
